import { Component } from '@angular/core';
import { ApiService } from 'app/api.service';
import { AppService } from 'app/app.service';
import { UIModalBaseComponent } from 'app/ui/ui-modal-base.component';

@Component({
	selector: 'app-integration-accounts-select-assignment-modal',
	templateUrl: './integration-accounts-select-assignment-modal.component.html'
})
export class IntegrationAccountsSelectAssignmentModalComponent extends UIModalBaseComponent {

	search = '';
	data = null;
	contextKey = '';

	// Xero returns client_search lists that we keep on the instance to avoid refetching the
	// whole chart of accounts on every open. The list depends on context (sales vs purchase)
	// and one modal instance serves both pickers, so cache per context rather than globally.
	private cache: { [key: string]: any } = {};

	constructor(
		public app: AppService,
		private api: ApiService,
	) {
		super();
	}

	// Accepts either a plain search string (legacy callers) or { search, context }.
	open(mdata: any = null) {
		const opts = typeof mdata === 'string' ? { search: mdata } : (mdata || {});
		const context = opts.context || '';

		this.search = opts.search || '';

		// Assign the context before searching so the request carries it. Swapping data out
		// is what lets a client_search list refetch when the context changes.
		if (this.contextKey !== context) {
			this.contextKey = context;
			this.data = this.cache[context] || null;
		}

		if (!this.data || (this.search && !this.data.client_search)) {
			this.searchItems();
		}
		this.modal.open();
	}

	searchItems() {
		if (!this.data || !this.data.client_search) {
			if (this.data) this.data.list = null;

			// Capture the context now: the user may reopen the picker for the other context
			// before this response lands, and it must not overwrite what that picker shows.
			const context = this.contextKey;
			this.api.settings.integrationAccountsSearchAssignments({ keywords: this.search, context }, data => {
				if (data?.client_search) this.cache[context] = data;
				if (this.contextKey === context) this.data = data;
			}, error => {
				this.app.notifications.showDanger(error.message);
				if (this.contextKey === context) this.data = [];
			});
		}
	}

	selectItem(item) {
		this.modal.close(item);
	}

}
